<template>
  <div class="header-client">
    <div @click="changeOrder">
      <label :for="column">{{ $t("b2c." + column) }}</label>
      <i
        class="fa"
        :class="{
          'fa-arrow-up': isAscending,
          'fa-arrow-down': isAscending === false,
          'fa-minus': isAscending === null,
        }"
      ></i>
    </div>
    <input class="header-client-input" :id="column" v-model="value" />
    <i class="fa fa-search search-icon"></i>
  </div>
</template>

<script>
export default {
  props: ["column", "filterVal", "valid", "isAscending", "validator"],
  methods: {
    changeOrder: function () {
      let orderBy = {
        column: this.column,
        isAscending: !this.isAscending,
      };
      this.$emit("updateOrderBy", orderBy);
    },
  },
  computed: {
    value: {
      get: function () {
        return this.filterVal;
      },
      set: function (value) {
        if (this.validator) {
          this.$emit("updateValidation", this.validator(value));
        }
        this.$emit("updateFilter", value);
      },
    },
  },
};
</script>
<style scoped>
.fa-minus,
.fa-arrow-up,
.fa-arrow-down {
  float: right;
}
.search-icon {
  position: absolute;
  right: 5px;
  bottom: 6px;
  color: hsla(0, 0%, 0%, 0.4);
}
.header-client:focus-within .search-icon {
  display: none;
}
.header-client {
  position: relative;
}
.header-client label {
  float: left;
  cursor: pointer;
}
.header-client .fa {
  cursor: pointer;
}

.header-client > input {
  width: 100%;
  padding-right: 1.5em;
}

.header > input:focus {
  border-color: #fff;
  border-bottom: 1px solid;
}
</style>
